export const localDate = (value) => new Date(`${String(value).slice(0, 10)}T00:00:00`);
export const dateKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
const addDays = (date, days) => { const next = new Date(date); next.setDate(next.getDate() + days); return next; };

export const dashboardRange = (period, anchor = new Date()) => {
  let start = localDate(dateKey(anchor));
  let end;
  if (period === 'year') { start = new Date(anchor.getFullYear(), 0, 1); end = new Date(anchor.getFullYear(), 11, 31); }
  else if (period === 'month') { start = new Date(anchor.getFullYear(), anchor.getMonth(), 1); end = new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0); }
  else if (period === 'week') { start = addDays(start, -start.getDay()); end = addDays(start, 6); }
  else { end = start; }
  return {start: dateKey(start), end: dateKey(end)};
};

export const previousDashboardRange = (range, period) => {
  const start = localDate(range.start);
  if (period === 'year') return dashboardRange('year', new Date(start.getFullYear() - 1, 0, 1));
  if (period === 'month') return dashboardRange('month', new Date(start.getFullYear(), start.getMonth() - 1, 1));
  const utcDay = value => {
    const [year, month, day] = value.split('-').map(Number);
    return Date.UTC(year, month - 1, day) / 86400000;
  };
  const days = utcDay(range.end) - utcDay(range.start) + 1;
  return {start: dateKey(addDays(start, -days)), end: dateKey(addDays(start, -1))};
};

export const dashboardOrderValue = (order) => order.order_status === 'Failed' ? 20 : Number(order.order_total || 0);
export const dashboardTotals = (orders, range) => orders.reduce((total, order) => {
  const date = String(order.property_date).slice(0, 10);
  if (date >= range.start && date <= range.end) { total.sales += dashboardOrderValue(order); total.orders += 1; }
  return total;
}, {sales: 0, orders: 0});

export const dashboardSeries = (orders, range, period) => {
  const start = localDate(range.start), end = localDate(range.end);
  const hourly = range.start === range.end;
  const monthly = period === 'year' || (end - start) / 86400000 > 62;
  const buckets = new Map();
  if (hourly) {
    for (let hour = 0; hour < 24; hour += 1) buckets.set(String(hour), {name: `${String(hour).padStart(2, '0')}:00`, value: 0, orders: 0});
  } else {
    const date = monthly ? new Date(start.getFullYear(), start.getMonth(), 1) : new Date(start);
    while (date <= end) {
      const key = monthly ? dateKey(date).slice(0, 7) : dateKey(date);
      buckets.set(key, {name: monthly ? date.toLocaleDateString('en-GB', {month: 'short', ...(period === 'year' ? {} : {year: 'numeric'})}) : period === 'week' ? date.toLocaleDateString('en-GB', {weekday: 'short'}) : period === 'month' ? String(date.getDate()) : date.toLocaleDateString('en-GB', {day: '2-digit', month: 'short'}), value: 0, orders: 0});
      if (monthly) date.setMonth(date.getMonth() + 1); else date.setDate(date.getDate() + 1);
    }
  }
  orders.forEach(order => {
    const date = String(order.property_date).slice(0, 10);
    if (date < range.start || date > range.end) return;
    const key = hourly ? String(new Date(order.created_at || `${date}T00:00:00`).getHours()) : monthly ? date.slice(0, 7) : date;
    const bucket = buckets.get(key);
    if (bucket) { bucket.value += dashboardOrderValue(order); bucket.orders += 1; }
  });
  return [...buckets.values()];
};
